import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.css'],
})
export class PopupDeleteComponent implements OnInit {
  isResetPassword: boolean = false;
  isDeleteUser: boolean = false;
  isConfirmAction: boolean = false;
  user: any;

  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {

  }

  save() {
    this.close.emit();
    this.activeModal.close();
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
